export default {
    pmusers_new_user: "New User",
    pmusers_edit_user: "Edit User",
    pmusers_user_has_been_created: "The user has been created",
    pmusers_user_has_been_edited: "The user has been edited",
    pmusers_user_firstname: "First Name",
    pmusers_user_lastName: "Last Name",
    pmusers_user_username: "Username",
    pmusers_user_email: "Email",
    pmusers_user_email_is_invalid: "Email is invalid",
    pmusers_user_password: "Password",
    pmusers_user_repeat_password: "Repeat Password",
    pmusers_user_rol: "Roles",    

    pmusers_min_chars_firname: "The first name must contain minimum chars:",
    pmusers_max_chars_firname: "The first name must contain maximum chars:",

    pmusers_min_chars_lastname: "The last name must contain minimum chars:",
    pmusers_max_chars_lastname: "The last name must contain maximum chars:",

    pmusers_min_chars_username: "The username must contain minimum chars:",
    pmusers_max_chars_username: "The username must contain maximum chars:",

    pmusers_min_chars_password: "The password must contain minimum chars:",
    pmusers_max_chars_password: "The password must contain maximum chars:",

    pmusers_message_error_create: "Unable to create the user due to an error",
    pmusers_message_error_edit: "Unable to edit the user due to an error",

    pmusers_is_restricted: "Is Restricted",
    pmusers_dealers: "Restricted to see this dealers",
    pmusers_dealer: "Dealer",
}